import React from 'react'
import _ from 'lodash'
import '../assets/css/components/vertical-tab-box.css'

class VerticalTabBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = { currentIndex: props.initialIndex }
  }

  render() {
    const { tabsHtml, contentsHtml } = this.props
    const { currentIndex } = this.state

    return (
      <div className='vertical-tab-box row'>
        <div className='col-md-5 tabs'>
          {_.map(tabsHtml, (html,index) =>
            <div
              key={'tab'+index}
              onClick={()=>this.setState({ currentIndex: index })}
              className={`tab ${currentIndex === index ? 'selected' : ''}`}>
              {html}
            </div>
          )}
        </div>
        <div className='col-md-7 contents'>
          {_.map(contentsHtml, (html,index) =>
            <div key={'content'+index} className={`content ${currentIndex === index ? '' : 'hidden'}`}>
              {html}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default VerticalTabBox
